export function Xcelera() {
	return <span className="font-mono font-semibold tracking-wide">xcelera</span>
}
